import React from "react";
import { useTranslation } from "react-i18next";
import { requestStatusColorClass } from "@companion-core/shared/app/Constants/myRequests";
import "@companion-core/web/src/Assets/Styles/scss/requestStatus.scss";

interface Props {
  status: string;
  style?: unknown;
  id?: string;
}

export const RequestStatus = ({ status, id }: Props) => {
  const { t } = useTranslation();

  return (
    <div
      className={`body-text-7 request-card__status request-card__status--${requestStatusColorClass[status]}`}
      data-testid="request-card__status">
      <p id={id}>{t(`request.my-requests.statusV2.${status}`)}</p>
    </div>
  );
};
